"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var CommentBubble_exports = {};
__export(CommentBubble_exports, {
  default: () => CommentBubble_default
});
module.exports = __toCommonJS(CommentBubble_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M9.07422 15.1133H5.77344C5.23958 15.1133 4.78385 14.9245 4.40625 14.5469C4.02865 14.1693 3.83984 13.7201 3.83984 13.1992V5.50391C3.83984 4.97005 4.02865 4.52083 4.40625 4.15625C4.78385 3.77865 5.23958 3.58984 5.77344 3.58984H16.1641C16.7109 3.58984 17.1732 3.77865 17.5508 4.15625C17.9284 4.52083 18.1172 4.97005 18.1172 5.50391V9.07812C17.9219 8.92188 17.7135 8.77865 17.4922 8.64844C17.2839 8.51823 17.0625 8.40104 16.8281 8.29688V5.50391C16.8281 5.33464 16.763 5.1849 16.6328 5.05469C16.5026 4.92448 16.3464 4.85938 16.1641 4.85938H5.77344C5.60417 4.85938 5.45443 4.92448 5.32422 5.05469C5.19401 5.1849 5.12891 5.33464 5.12891 5.50391V13.1992C5.12891 13.3685 5.19401 13.5182 5.32422 13.6484C5.45443 13.7786 5.60417 13.8438 5.77344 13.8438H8.83984C8.85286 14.0651 8.87891 14.2865 8.91797 14.5078C8.95703 14.7161 9.00911 14.918 9.07422 15.1133ZM8.9375 12.4375H7.6875C7.51823 12.4375 7.375 12.3789 7.25781 12.2617C7.14062 12.1445 7.08203 12.0013 7.08203 11.832C7.08203 11.6628 7.14062 11.5195 7.25781 11.4023C7.375 11.2852 7.51823 11.2266 7.6875 11.2266H9.30859C9.23047 11.4219 9.15885 11.6237 9.09375 11.832C9.02865 12.0273 8.97656 12.2292 8.9375 12.4375ZM10.0312 10.0352H7.6875C7.51823 10.0352 7.375 9.97656 7.25781 9.85938C7.14062 9.74219 7.08203 9.59896 7.08203 9.42969C7.08203 9.26042 7.14062 9.11719 7.25781 9C7.375 8.88281 7.51823 8.82422 7.6875 8.82422H11.3203C11.0729 8.99349 10.8385 9.18229 10.6172 9.39062C10.4089 9.58594 10.2135 9.80078 10.0312 10.0352ZM14.3281 7.61328H7.6875C7.51823 7.61328 7.375 7.55469 7.25781 7.4375C7.14062 7.32031 7.08203 7.18359 7.08203 7.02734C7.08203 6.85807 7.14062 6.71484 7.25781 6.59766C7.375 6.48047 7.51823 6.42188 7.6875 6.42188H14.3281C14.4974 6.42188 14.6406 6.48047 14.7578 6.59766C14.875 6.71484 14.9336 6.85807 14.9336 7.02734C14.9336 7.18359 14.875 7.32031 14.7578 7.4375C14.6406 7.55469 14.4974 7.61328 14.3281 7.61328ZM14.543 17.75C13.957 17.75 13.4036 17.6393 12.8828 17.418C12.362 17.1966 11.9062 16.8971 11.5156 16.5195C11.125 16.1289 10.819 15.6732 10.5977 15.1523C10.3763 14.6315 10.2656 14.0781 10.2656 13.4922C10.2656 12.9062 10.3763 12.3594 10.5977 11.8516C10.819 11.3307 11.125 10.8815 11.5156 10.5039C11.9062 10.1133 12.362 9.80729 12.8828 9.58594C13.4036 9.36458 13.957 9.25391 14.543 9.25391C15.1419 9.25391 15.7018 9.36458 16.2227 9.58594C16.7435 9.80729 17.1927 10.1133 17.5703 10.5039C17.9609 10.8815 18.2669 11.3307 18.4883 11.8516C18.7227 12.3594 18.8398 12.9062 18.8398 13.4922C18.8398 14.0781 18.7227 14.6315 18.4883 15.1523C18.2669 15.6732 17.9609 16.1289 17.5703 16.5195C17.1927 16.8971 16.7435 17.1966 16.2227 17.418C15.7018 17.6393 15.1419 17.75 14.543 17.75Z",
      fill: "currentColor"
    }
  )
);
const SvgCommentBubble = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var CommentBubble_default = SvgCommentBubble;
